import React from "react";
import { connect } from "react-redux";
import SelectOptionsView from "pages/Contracts/SelectOptionsView";
import {UI_LAYER_DROPDOWN_OVER_POPUP} from "../../../constants/uiLayers";
import "pages/Styles/UIKit_v2.sass";

export type AccountTypeProps = {
    title: string,
    role: string,
    allowNotSelectedOptions?: boolean,
    onChange: Function
}

export const clientRoles: string[] = ['entrepreneur', "customer"]

export function clientRoleTitle(role: string): string {
    switch (role) {
        case clientRoles[0]:
            return "ИП или ООО"
        case clientRoles[1]:
            return "Физ. лицо или самозанятый"
        default:
            return "Не выбрано"
    }
}

const ROLE_OPTIONS = [
    { id: clientRoles[0], title: clientRoleTitle(clientRoles[0]) },
    { id: clientRoles[1], title: clientRoleTitle(clientRoles[1]) },
]

export let ChooseAccountTypeFrom: any = function ChooseAccountTypeFrom(props: AccountTypeProps) {
    const options = props.allowNotSelectedOptions
        ? [{ id: '', title: 'Не выбрано' }, ...ROLE_OPTIONS]
        : ROLE_OPTIONS;

    const selectedOption = props.role
        ? options.find(o => o.id === props.role) ?? null
        : null;

    return (
        <div className="choose-account-type-v2 ui-kit-v2">
            <div className="choose-account-type-v2__label Subheader_14">
                {props.title}
            </div>
            <SelectOptionsView
                options={options}
                selectedOption={selectedOption}
                onSelectOption={(option: { id: string; title: string } | null) => {
                    const role = option?.id ?? '';
                    if (!props.allowNotSelectedOptions && !role) {
                        return;
                    }
                    props.onChange(role);
                }}
                placeholder="Выберите"
                freeSolo={false}
                width="full"
                popperZIndex={UI_LAYER_DROPDOWN_OVER_POPUP}
            />
        </div>
    );
}

ChooseAccountTypeFrom = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({ $commitToStore: (data: any) => dispatch({ ...data, type: 'S' }) })
)(ChooseAccountTypeFrom)
